import React, { FC, useContext } from 'react'
import classnames from 'classnames'
import { useTranslations } from 'next-intl'
import { Languages } from '../../interfaces/common'
import { LocaleContext } from '../LocaleContext/LocaleContext'
import { LocalizedLogo } from '../LocalizedLogo/LocalizedLogo'
import style from './RegistrationLogo.module.css'

const logoClassNameByLang = {
  [Languages.RU]: style.logoRU,
  [Languages.KZ]: style.logoKZ,
  [Languages.UZ]: style.logoUZ,
}

interface IRegistrationLogoProps {
  className?: string
}

const HEADER_LOGO_LINK = 'app.formComponents.header.logoLink'

export const RegistrationLogo: FC<IRegistrationLogoProps> = ({ className }) => {
  const t = useTranslations()
  const { locale } = useContext(LocaleContext)
  const classNames = classnames(className, logoClassNameByLang[locale])
  const headerLogoLink = t(HEADER_LOGO_LINK)

  return locale === Languages.RU ? (
    <a href={headerLogoLink}>
      <LocalizedLogo className={classNames} locale={locale} />
    </a>
  ) : (
    <LocalizedLogo className={classNames} locale={locale} />
  )
}

RegistrationLogo.displayName = 'RegistrationLogo'
